/**
 * DOM injection of piece + theme CSS. Two reasons we don't use
 * `import './foo.css'`:
 *   1. The piece URLs come from webpack-resolved SVG imports — using them in
 *      a static .css file would require asset-path config we don't control.
 *   2. The theme CSS derives colors from CCColors at runtime.
 *
 * Replaces the previous style tag (if any) so hot-reload picks up edits to
 * pieces.ts / themes.ts without a full page refresh.
 */
import {PIECE_CSS} from './pieces';
import {THEME_CSS} from './themes';

const STYLE_ID = 'circlechess-chessground-styles';

const CONTENT = PIECE_CSS + '\n' + THEME_CSS;

export function injectChessgroundStyles() {
  if (typeof document === 'undefined') return;
  const existing = document.getElementById(STYLE_ID);
  if (existing && existing.textContent === CONTENT) return;
  if (existing) existing.remove();
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = CONTENT;
  document.head.appendChild(style);
}
